<template>
  <div class="detail-base-info">
    <common-card :card-title="cardTitle">
      <div class="container">
        <div class="left-avatar-container">
          <el-avatar :size="60" :src="avatarUrl " />
        </div>
        <div
          v-if="userDetailPairs && userDetailPairs.length > 0"
          class="right-descriptions"
        >
          <template v-for="(item, index) in userDetailPairs">
            <div
              v-if="userFieldMap[item[0]]"
              :key="index"
              class="description-item"
            >
              <div class="description-field">
                <div class="field-test">{{ userFieldMap[item[0]] + ": " }}</div>
              </div>
              <div class="description-field-value">
                <div class="field-value">{{ item[1] }}</div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </common-card>
  </div>
</template>

<script>
/**
 * 个人资料-基本信息组件
 */
import DefaultUserLogo from '@/assets/default_user.png'
import CommonCard from '@/components/CommonCard'
import { mapGetters } from 'vuex'
import { userFieldMap } from '../const'
export default {
  name: 'DetailBaseInfo',
  components: {
    CommonCard
  },
  computed: {
    ...mapGetters(['userDetailPairs', 'avatarUrl'])
  },
  data() {
    return {
      userFieldMap,
      logoDeafult: DefaultUserLogo,
      cardTitle: '基本信息'
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-base-info {
  margin-top: 18px;
  .container {
    display: flex;
    align-items: center;
    padding-left: 20px;
    .left-avatar-container {
      display: flex;
      width: 10rem;
      align-items: center;
      flex-direction: column;
      // margin-left: -25px;
      margin-top: 10px;
      .user-name {
        font-size: 12px;
        margin-top: 8px;
      }
    }
    .right-descriptions {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      padding-top: 20px;
      padding-left: 40px;
      .description-item {
        display: flex;
        width: 15.5rem;
        font-size: 14px;
        margin-bottom: 14px;
        .description-field {
          margin-right: 6px;
          font-weight: bold;
          color: #003666;
        }
        .description-field-value {
          color: #4d4f53;
        }
      }
    }
  }
}
</style>
